import { changeLastPayrollDateAction } from 'reg_redesign/actions';
import { mapDispatchDatePicker } from 'reg_redesign/redux/connectFunctions';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import DateMask from 'components/rebrand/DateMask';
import DatePicker from 'components/component_lib/DatePicker';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

export default {
  defaultNextPage: 'page-9',
  content: [
    configureProgressBar(39),
    configureTitle('When were you last paid?'),
    {
      component: DatePicker,
      name: 'lastPayrollDate',
      dispatchOverride: mapDispatchDatePicker,
      props: {
        id: 'lastPayrollDate',
        label: 'Last Pay Date',
        InputProps: {
          inputComponent: DateMask
        },
        onDatePickerChange: changeLastPayrollDateAction,
        onTextFieldChange: changeLastPayrollDateAction,
        onMount: changeLastPayrollDateAction,
        minDate: -40,
        maxDate: 0
      }
    },
    configureTitle('When will you next be paid?', 'nextPayrollDateTitle'),
    {
      component: DatePicker,
      name: 'nextPayrollDate',
      dispatchOverride: mapDispatchDatePicker,
      props: {
        id: 'nextPayrollDate',
        label: 'Next Pay Date',
        InputProps: {
          inputComponent: DateMask
        },
        minDate: 0,
        maxDate: 18
      }
    },
    nextButtonConfig('page-8.1')
  ]
};
